(ns frontend.views.activity-feed
  "The roadmap Activity Feed's event timestamps, rendered in the browser
  so they show in the viewer's timezone, which the server cannot know."
  (:require
   [common.util          :as u]
   [opengb.i18n          :refer [tr]]
   [reagent.dom.client   :as rg-dom-client]
   [shadow.graft         :as graft]
   [tailwind-hiccup.core :refer [tw]]))

(defn- OccurredAt
  [{:keys [occurred-at]}]
  [:time (tw [:text-sm :text-neutral-4] {:date-time occurred-at})
   (tr :backend.views.activity-feed/occurred-at {:WHEN (js/Date. occurred-at)})])

(defmethod graft/scion (u/->scion-id :frontend.views.activity-feed/OccurredAt)
  [data container]
  (let [root (rg-dom-client/create-root container)]
    (rg-dom-client/render root [OccurredAt data])))
